import { Component } from '@angular/core';
import { AppInjector } from './_services/app-injector.service';
import { UtilitiesService } from './_services/utilities.service';
import { MediaObserver } from '@ngbracket/ngx-layout';
import { Router } from "@angular/router";
import { AuthenticationService, UserService } from './_services';
import { FeatureHelperService } from './_helpers/feature-helper/feature-helper.service';
@Component({
    template: '',
    standalone: false
})
export class BaseComponent {

  protected utilitiesService: UtilitiesService;
  public media: MediaObserver;
  public router: Router;
  public authService: AuthenticationService;
  public userService: UserService;
  private baseFeatureHelperService: FeatureHelperService;

  constructor() {
    const injector = AppInjector.getInjector();
    this.utilitiesService = injector.get(UtilitiesService);
    this.media = injector.get(MediaObserver);
    this.router = injector.get(Router);
    this.authService = injector.get(AuthenticationService);
    this.userService = injector.get(UserService);
    this.baseFeatureHelperService = injector.get(FeatureHelperService);
    this.verifyUrl();
    //this.checkUser();
  }

  private verifyUrl() {
    
    if (this.router.url.indexOf("tcdashboard") > -1) {
      let featureList = new Array<string>();
      featureList.push("TcDashboardView");

      let currentUserFeatures = this.baseFeatureHelperService.checkFeaturePermissions(featureList);

      if (!currentUserFeatures.filter(f => f.feature === "TcDashboardView")[0].enabled) {
        this.router.navigate(['/home']);
      }
    }
  }

  // private checkUser() {
  //   this.userService.getById(this.authService.userSessionData.currentUser.id).subscribe((data: any) => {
  //     if (window.location.pathname != "/student-home" && !data.active) {
  //       this.router.navigate(['/login']);
  //     }
  //   })
  // }
}         
